module.exports = __webpack_public_path__ + "ce09a2dfa196f00a66cb071d8cc0fe1a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-16.png
// module id = 3072
// module chunks = 0